import type { OnboardingStep } from "@safers/pwa";

type HandoffStep = Extract<OnboardingStep, { kind: "open-app" } | { kind: "enable-notification" }>;

interface Props {
  step: HandoffStep;
  busy: boolean;
}

/**
 * 설치된 앱이 있는데 브라우저로 들어온 근로자를 앱으로 넘기는 전체 화면.
 *
 * 닫기가 없다 — QR 로 진입한 근로자가 브라우저에 머물면 위험 알림을 놓친다.
 * 브라우저에서 설치된 앱을 실행시키는 API 는 없으므로 안내가 유일한 수단이다.
 *
 * 알림 권한을 앱이 아니라 여기서 먼저 받는 이유: 권한은 오리진 단위라
 * 브라우저에서 허용해 두면 설치된 앱이 그대로 물려받는다.
 */
export function AppHandoffScreen({ step, busy }: Props) {
  const askNotification = step.kind === "enable-notification";

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 bg-slate-100 p-8 text-center">
      <img
        src={`${import.meta.env.BASE_URL}icons/icon-192.png`}
        alt="SAFERS"
        className="h-24 w-24 rounded-3xl shadow-md"
      />

      <div>
        <div className="text-xl font-bold text-neutral-800">
          {askNotification ? "설치 완료" : "이제 앱으로 열어주세요"}
        </div>
        <p className="mt-2 text-sm leading-relaxed text-neutral-500">
          {askNotification ? (
            <>
              알림을 켜면 현장의 위험 경보를
              <br />
              즉시 받아볼 수 있습니다.
            </>
          ) : (
            <>
              이 브라우저 창을 닫고
              <br />홈 화면의 <b className="text-brand">SAFERS</b> 아이콘으로 열어 주세요.
              <br />
              위험 알림은 설치한 앱에서 받을 수 있습니다.
            </>
          )}
        </p>
      </div>

      {step.kind === "enable-notification" && (
        <button
          type="button"
          onClick={() => void step.request()}
          disabled={busy}
          className="w-full max-w-xs rounded-xl bg-brand py-3 text-sm font-bold text-white disabled:opacity-60"
        >
          {busy ? "설정 중…" : "알림 켜기"}
        </button>
      )}
    </main>
  );
}
